import React from "react";
import Typewriter from "typewriter-effect"; // 1. Import library

function Slider() {
  return (
    <>
      <div
        className="content-section d-flex align-items-center"
        style={{
          backgroundColor: "#097969",
          minHeight: "500px",
          padding: "60px 0"
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* TEXT */}
            <div className="col-lg-6 col-12 text-white text-center text-lg-start">
              <h1 style={{ fontSize: "50px", fontFamily: "serif" }}>
                Simplify School
              </h1>
              <h1 style={{ fontSize: "50px", fontFamily: "serif" }}>
                Supply Shopping
              </h1>

              {/* 2. Typewriter Effect yahan add kiya hai */}
              <div style={{ fontSize: "22px", marginTop: "20px", fontWeight: "300", height: "60px" }}>
                <Typewriter
                  options={{
                    strings: [
                      "One platform connecting schools and parents <br>Manage uniforms with ease Order books and supplies instantly.",
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 30,
                  }}
                />
              </div>
              <button className="btn-section">
                Shop Now
              </button>
            </div>

            {/* IMAGE */}
            <div className="col-lg-6 col-12 mt-5 mt-lg-0 d-flex justify-content-center">
              <img
                src="https://img.freepik.com/premium-photo/digital-art-young-students-attending-school_198067-1070756.jpg"
                alt="Students"
                className="img-fluid"
                style={{
                  height: "400px",
                  width: "100%",
                  maxWidth: "550px",
                  objectFit: "cover",
                  borderRadius: "20px", // Thoda zyada rounded for modern look
                  boxShadow: "0px 20px 50px rgba(0,0,0,0.3)"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Slider;